import React from "react";
import { Typography, Card, CardContent, Grid, IconButton } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import FileItemMenu from "./FileItemMenu";

const FileList = ({ files, downloadFile, handleSingleFileDelete }) => {
  return (
    <Grid
      container
      spacing={1.5}
      sx={{ marginTop: "10px", ml: 0.5, maxWidth: "70%" }}
    >
      {files.map((file) => (
        <Grid item xs={12} sm={6} md={4} lg={4} key={file.id}>
          <Card
            variant="outlined"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: "8px",
              cursor: "pointer",
              position: "relative",
              minHeight: "160px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
              borderRadius: "6px",
              border: "1px solid grey",
              width: "95%", // Reduce width slightly
              margin: "5px auto", // Center the card
            }}
          >
            {/* More Options Button */}
            <IconButton sx={{ position: "absolute", top: 5, right: 5 }}>
              <FileItemMenu
                onDownload={() => {
                  downloadFile(file.id);
                }}
                onDelete={() => handleSingleFileDelete(file.id)}
                disableDelete={
                  file.name == "IncorporationDocument.pdf" ||
                  file.name == "sensitiveNameApproval.pdf"
                    ? true
                    : false
                }
              />
            </IconButton>

            {/* File Icon */}
            <DescriptionIcon
              sx={{ fontSize: "70px", color: "#4caf50", marginBottom: "5px" }}
            />

            {/* File Name */}
            <CardContent
              sx={{ padding: "5px 0 0 5px", textAlign: "left", width: "100%" }}
            >
              <Typography
                variant="body1"
                fontWeight="bold"
                noWrap
                sx={{ maxWidth: "100%" }}
              >
                {file.name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {`${(file.size / 1024).toFixed(2)} KB • ${new Date(
                  file.createdAt
                ).toLocaleDateString()}`}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default FileList;
